import type { ReactNode } from "react";

type Props = {
  label: ReactNode;
  onClick: () => void;
  disabled?: boolean;
};

export default function StickyActionButton({
  label,
  onClick,
  disabled,
}: Props) {
  return (
    <div
      className={`fixed inset-x-0 bottom-0 z-20 mx-auto max-w-xl px-3 pb-3 pt-2`}
    >
      <div className="w-full rounded-full bg-background">
        <button
          type="button"
          onClick={onClick}
          disabled={disabled}
          className="w-full rounded-full bg-primary py-3 text-sm font-bold text-white shadow-sm transition active:scale-[0.99] disabled:opacity-60 disabled:shadow-none"
        >
          {label}
        </button>
      </div>
      <div className="safe-area-inset-bottom w-full" />
    </div>
  );
}
